import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { BarChartModule } from '@swimlane/ngx-charts';
import { NoDataContainerComponent } from '../no-data-container/no-data-container.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-bar-horizontal',
  templateUrl: './bar-horizontal.component.html',
  styleUrls: ['./bar-horizontal.component.css'],
  imports: [BarChartModule, NoDataContainerComponent, TranslocoPipe],
})
export class BarHorizontalComponent implements OnInit, OnChanges {
  @Input() answersDistribution: {
    correct: number;
    incorrect: number;
    omitted: number;
  } = { correct: 0, incorrect: 0, omitted: 0 };
  @Input() isFilterOpen = false;
  view: number[] = [330, 150];
  answers: { name: string; value: number }[] = [];
  statusDetail = 'success';
  constructor(private transloco: TranslocoService) {}

  ngOnInit(): void {
    this.answers = [
      {
        name: this.transloco.translate(
          'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.CORRECT',
        ),
        value: this.answersDistribution.correct,
      },
      {
        name: this.transloco.translate(
          'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.INCORRECT',
        ),
        value: this.answersDistribution.incorrect,
      },
      {
        name: this.transloco.translate(
          'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.OMITTED',
        ),
        value: this.answersDistribution.omitted,
      },
    ];
  }

  ngOnChanges(): void {
    if (this.isFilterOpen) this.view = [240, 150];
    else this.view = [330, 150];
  }

  xAxisFormat(val: any) {
    if (val % 1 > 0) return '';
    return val;
  }

  colorScheme = {
    domain: ['#51D3C5', '#FF7070', '#5072FF'],
  };

  customColors = [
    {
      name: this.transloco.translate(
        'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.CORRECT',
      ),
      value: '#51D3C5',
    },
    {
      name: this.transloco.translate(
        'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.INCORRECT',
      ),
      value: '#FF7070',
    },
    {
      name: this.transloco.translate(
        'pages.TRAINING-QUIZZES.CLASSROOM-RESULTS.OMITTED',
      ),
      value: '#5072FF',
    },
  ];
}
